<template>
    <UserContentWrapper
      :title="t('account.deactivate')"
      @back="$emit('back')"
    >
        <div class="n-user-set-bio">
            <AppBackButton
            :linkMode="true"
            link="/user/settings"
            class="n-user-deactivate"
        />

        <AppTooltip class="user-questionnaires">
            <p class="mb-2">
                Вы можете отключить учетную запись, по прошествии 30 календарных дней она будет удалена из системы.
            </p>
            <p class="mb-2">
                Для отключения учетной записи <strong>включите</strong> ползунок подтверждения отключения учетной 
                записи и нажмите на кнопку <strong>сохранить</strong>. После этого произойдет выход из системы.
            </p>
            <p class="mb-2">
                Если в этот период вы передумаете, на странице входа можно запросить отправку кода для активации на 
                адрес электронной почты, указанный при регистрации.
            </p>
        </AppTooltip>


        <AppSwitch
            @switch="confirmDeactivateAccount = !confirmDeactivateAccount"
            :chosed="confirmDeactivateAccount"
            :okLabel="`${t('deactivate.confirmed')}`"
            :nokLabel="`${t('confirm.deactivate')}`"
            class="n-user-set-bio__input mt-6"
        ></AppSwitch>

        <AppButton
            @click="$emit('deactivateAccount')"
            :disabled="!confirmDeactivateAccount"
            class="n-user-set-bio__save"
        >
            {{ t("save") }}
        </AppButton>
    </div>
      
    </UserContentWrapper>
  </template>
  
  <script>
  import AppSwitch from "@/elements/AppSwitch.vue";

  import AppButton from "@/elements/AppButton";
  import UserContentWrapper from "@/elements/UserContentWrapper.vue";
  import AppBackButton from "@/elements/AppBackButton.vue";
  import AppTooltip from "./AppTooltip.vue";
  
  import { setValidationStatusClass } from "@/utils/validation";
  
  import { t } from "@/utils/translate";
  import { ref } from "vue";
  
  import { useVuelidate } from "@vuelidate/core";
  import { minLength, required } from "@vuelidate/validators";
  
  export default {
    emits: ["changeEmail"],
    components: { AppButton, UserContentWrapper, AppBackButton , AppSwitch, AppTooltip},
    setup() {
      const email = ref("");
      const confirmDeactivateAccount = ref(false);
  
      const eRules = {
        email: { required, min: minLength(6) },
      };
  
      const ve$ = useVuelidate(eRules, {
        email: email,
      });
  
      return { email, t, ve$, setValidationStatusClass, confirmDeactivateAccount };
    },
  };
  </script>
  
  <style lang="scss">
  
  .n-user-set-bio {
  &__input + .n-user-set-bio__input {
    margin-top: 16px;
  }

  &__save {
    @include button-default;
    margin-top: 30px;
  }
}

  .user-deactivate {
  &__template {
    @include card;
    padding: 0;

    & + .user-deactivate__template {
      margin-top: 16px;
    }

    button {
      @include button-default;
      margin-top: 30px;
    }

    a {
      @include link-default;
      line-height: 30px;
      padding: 16px;
      align-items: center;
      cursor: pointer;
      transition: all 0.2s;
    }

    &:hover {
      background-color: $accent-1;

      a,
      span {
        color: #fff;
      }

      span {
        background-color: transparent;
      }
    }
  }
}
 
  </style>
  